import { Injectable } from '@angular/core';
import { DatabaseProvider } from '../database/database';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { TranslateProvider } from '../translate/translate';

@Injectable()
export class AdvalvasItemStoreProvider {

	public db = new DatabaseProvider();
	public advalvasList: BehaviorSubject<any> = new BehaviorSubject([]);

	constructor(
		private translateProvider: TranslateProvider
	) {

	}

	addBatch(advalvasList) {


		return new Promise((resolve, reject) => {

			this.db.advalvas.clear().then(() => {

				this.db.advalvas.bulkAdd(advalvasList).then((data) => {
					this.loadList();
					resolve(data)
				}).catch((e) => {
					reject(e)
				})

			}).catch((e) => {

				reject(e)

			})

		})

	}

	loadList() {

		return new Promise((resolve, reject) => {

			this.db.advalvas.toArray().then((list) => {

				this.manipulateList(list).then((filteredList) => {

					this.advalvasList.next(filteredList);

					resolve()

				}).catch((e) => { reject(e) });

			}).catch((e)=>{

				reject(e);
				
			});

		})



	}

	manipulateList(advalvasList) {


		return new Promise((resolve, reject) => {

			let list = [];

			for (var i = 0; i < advalvasList.length; i++) {

				let advtitle = advalvasList[i].advtitle;
				let body = '';
				// let type = '';
				let advdate = '';
				advtitle = '';
				body = '';
				let icon = '';
				let color = '';
				let advtime = '';
				let className = ""

				if (advalvasList[i].advcategory == 'newbewoner') {
					let tmpadvdate = new Date(advalvasList[i].advdate);
					advdate = tmpadvdate.getDate() + '/' + ((tmpadvdate.getMonth() + 1) < 10 ? '0' : '') + (tmpadvdate.getMonth() + 1) + '/' + tmpadvdate.getFullYear();
					advtitle = this.translateProvider.getTranslateKey('NEW_HABITANT');
					body = advalvasList[i].name + '<br/>Kamer:' + advalvasList[i].room + '<br/>Datum:' + advdate;
					icon = 'ion-ios-person';
					color = '#49c21f';
					className = "newbewoner";
				}
				if (advalvasList[i].advcategory == 'birthday') {
					let tmpadvdate = new Date(advalvasList[i].advdate);
					advdate = tmpadvdate.getDate() + '/' + ((tmpadvdate.getMonth() + 1) < 10 ? '0' : '') + (tmpadvdate.getMonth() + 1) + '/' + tmpadvdate.getFullYear();
					advtitle = this.translateProvider.getTranslateKey('BIRTHDAY');
					body = advalvasList[i].name;
					icon = 'ion-md-wine';
					color = '#c92362';
					className = "birthday";
				}
				if (advalvasList[i].advcategory == 'text' && advalvasList[i].advtexttype == 'warning') {
					let tmpadvdate = new Date(advalvasList[i].advdate);
					advdate = tmpadvdate.getDate() + '/' + ((tmpadvdate.getMonth() + 1) < 10 ? '0' : '') + (tmpadvdate.getMonth() + 1) + '/' + tmpadvdate.getFullYear();
					advtitle = advalvasList[i].advtitle;
					body = '';
					icon = 'ion-ios-information-circle';
					color = '#FF7600';
					className = "text_warning";
				}
				if (advalvasList[i].advcategory == 'text' && advalvasList[i].advtexttype == 'urgent') {
					let tmpadvdate = new Date(advalvasList[i].advdate);
					advdate = tmpadvdate.getDate() + '/' + ((tmpadvdate.getMonth() + 1) < 10 ? '0' : '') + (tmpadvdate.getMonth() + 1) + '/' + tmpadvdate.getFullYear();
					advtitle = advalvasList[i].advtitle;
					body = '';
					icon = 'ion-ios-information-circle';
					color = '#DA4541';
					className = "text_urgent";
				}
				if (advalvasList[i].advcategory == 'text' && advalvasList[i].advtexttype == 'info') {
					let tmpadvdate = new Date(advalvasList[i].advdate);
					advdate = tmpadvdate.getDate() + '/' + ((tmpadvdate.getMonth() + 1) < 10 ? '0' : '') + (tmpadvdate.getMonth() + 1) + '/' + tmpadvdate.getFullYear();
					advtitle = advalvasList[i].advtitle;
					body = '';
					icon = 'ion-ios-information-circle';
					color = '#0094DC';
					className = "text_info";
				}
				if (advalvasList[i].advcategory == 'agenda') {
					let tmpadvdate = new Date(advalvasList[i].advdate);
					advdate = tmpadvdate.getDate() + '/' + ((tmpadvdate.getMonth() + 1) < 10 ? '0' : '') + (tmpadvdate.getMonth() + 1) + '/' + tmpadvdate.getFullYear();
					advtime = advalvasList[i].advtimefrom;

					if (advalvasList[i].advtimetill != '') {
						advtime += ' - ' + advalvasList[i].advtimetill;
					}
					advtitle = advalvasList[i].advtitle;
					body = advtime;
					icon = 'ion-ios-calendar';
					color = '#00b185';
					className = "agenda";
				}
				if (advalvasList[i].advcategory == 'newcollaegue') {
					advtitle = this.translateProvider.getTranslateKey('NEW_COWORKER');
					body = '<b>' + advalvasList[i].name + '</b><br/>' + advalvasList[i].function;
					icon = 'ion-ios-person';
					color = '#9c00a6';
					className = "newcollaegue";
				}

				if (advalvasList[i].advtext != '' && advalvasList[i].advtext != null && advalvasList[i].advtext != 'null') {
					body += '<br/><span class="clickformore">...</span>';
				}

				var itemWidth = "95%";

				list.push({
					id: advalvasList[i].id,
					style: 'background-color:' + color + ';color:white;width:' + itemWidth + ';margin:0px auto;margin-top:10px;margin-bottom:10px;' +
						'box-shadow: 2px 2px #f3f3f3;',
					class: className,
					advtitle: advtitle,
					advbody: body,
					advtext: advalvasList[i].advtext,
					fadvdate: advalvasList[i].fadvdate,
					advcategory: advalvasList[i].advcategory,
					icon: icon
				});
			}

			resolve(list);
		})
	}

}



// WEBPACK FOOTER //
// ./src/providers/advalvas-item-store/advalvas-item-store.ts